import {Component, Expressions} from '@packages/systems/wfdl';
import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {getGuid, NativeId} from '@packages/systems/core/utils/NativeIdUtils';
import {Qualified} from '@packages/systems/wfdl-Qualified';
import {findSlotDefaultElement} from '@packages/systems/component-slots';

export function getInstancesFromRendererNativeIdPath(
  rendererNativeIdPath: NativeId[],
  rootComponentType: Qualified<Component.ComponentName>,
  componentMap: Component.ComponentMap
): ExpressionElement[] {
  const instances: ExpressionElement[] = [];
  let component = componentMap.get(rootComponentType);
  let componentType = rootComponentType;

  if (!component) {
    return [];
  }

  for (const instanceNativeId of rendererNativeIdPath) {
    const instanceId = getGuid(instanceNativeId);
    // Must resolve the same way getElementAndComponentTypeByRendererNativeIdPath
    // does, or a slot-default path keys its data paths off an empty instance key
    // and the element's own lookup misses.
    const instance =
      Expressions.getElementById(Component.getRender(component), instanceId) ??
      findSlotDefaultElement(null, componentMap, componentType, instanceId)
        ?.element;
    if (!instance) {
      return [];
    }
    const nextComponent = componentMap.get(instance.type);
    if (!nextComponent) {
      return [];
    }

    instances.push(instance);
    componentType = instance.type;
    component = nextComponent;
  }

  return instances;
}
